import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GetLeadByELauchIdGQL } from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";

export interface DialogData {
  eLaunchId: string;
  content: string;
}

@Component({
  selector: "whatsapp-contact-dialog",
  templateUrl: "whatsapp-contact-dialog.html",
  styleUrls: ['./whatsapp-contact-dialog.css']
})
export class WhatsappContactDialog {
  contactList: any;
  selected: any;
  value: any;
  eLaunchId: any;
  constructor(
    private getLeadByELauchIdGQL: GetLeadByELauchIdGQL,
    private snackBarService: SnackBarService,
    public dialogRef: MatDialogRef<WhatsappContactDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.eLaunchId = this.data?.eLaunchId;
    this.getData();
  }

  private getData() {
    this.getLeadByELauchIdGQL.fetch({eLaunchId: this.eLaunchId}).subscribe((result) => {
      if (result.errors) {
        this.snackBarService.showQueryError(result.errors);
      }
      this.contactList = result.data.getLeadByELaunchId;
    });
  }

  submit() {
    if (this.data?.content && this.selected) {
      this.data.content = encodeURI(this.data.content);
      var win = window.open(
        `https://wa.me/${this.selected}?text=${this.data.content}`,
        "_blank"
      );
      win.focus();
    }
  }
}
